import store from '../store/index';
import { mutationTypes } from '../types';
import { i18n } from './i18n';
import { meaning } from '../tools/consts';
export default (error, _options = {}) => {
	const options = Object.assign(
		{
			sticky: false,
			title: null,
			type: meaning.error,
			timeSpan: 5000,
			templateData: null
		},
		_options
	);
	let body = i18n.t('error.' + error.message);
	if (options.templateData) {
		body = body.replace(/%(\w*)%/g, ( match, key ) => options.templateData[key] || '');
	}
	store.commit(mutationTypes.sendMessage, {
		type: options.type,
		body,
		title: options.title,
		sticky: options.sticky,
	});
	console.warn(error);
};
